import React from 'react';
import PublishInfo from '../components/operatingStatistics/publishInfo';
import HotStory from '../components/operatingStatistics/hotStory';
import RecentlyPublish from '../components/operatingStatistics/recentlyPublish';
import FansInfo from '../components/operatingStatistics/fansInfo';
import './operatingStatistics.scss'

class OperatingStatistics extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    render(){
        let height = window.innerHeight - 90
        return(
            <div className="operating-statistics" style={{ height}}>
                {/* <div className="operating-statistics-title">运营统计</div> */}
                <div className="operating-statistics-wrap">
                    <PublishInfo />
                    <div className="operating-statistics-wrap-middle">
                        <RecentlyPublish />
                        <FansInfo />

                    </div>
                    <div className="operating-statistics-wrap-bottom">
                        <HotStory resourceType="1"/>
                         <HotStory resourceType="2"/>
                         <HotStory resourceType="3"/>
                    </div>

                </div>
            </div>
        )
    }
}

export default OperatingStatistics